export const API_URL='https://esimapi.altius.cc';
// export const API_URL='http://localhost:8080';
// export const API_URL = 'https://esimgktuat.altius.cc';
// export const API_URL='http://10.5.0.176:8080';

//For FAQ installation link
// export const React_URL = 'https://uat.eroaming.global/';
export const React_URL = 'https://eroaming.global/';
// export const React_URL = 'https://localhost:3000/';

//recaptcha data
export const REACT_APP_SITE_KEY = "6LcNGhgqAAAAAJceyiNR3d9vJb74UxULd9kJ1nYQ";

//vendors
export const NETWORK3_VENDOR = 4;
export const MAYA_VENDOR = 2;

//plan category
export const DATA_ONLY = 1;
export const CALLS_AND_SMS = 2;
export const DATA_CALLS_SMS = 3;

// bundle
export const ONE_TIME_BUNDLE_ID = 1;
export const RECURRING_BUNDLE_ID = 2;

//plan type
export const PLAN_TYPE_LOCAL = 1;
export const PLAN_TYPE_REGIONAL = 2;
export const PLAN_TYPE_GLOBAL = 3;

// payment gateway
export const PAYMENT_GATEWAY_PAY360 = 1;
export const PAYMENT_GATEWAY_STRIPE = 2;

export const WEBSITE_SOURCE_ID = 4;

export const RESTRICTED_COUNTRY_CODE = ["AE"];

export const isUserRestrictedForPlan = (userCountryCode, targetPlanCountryCode) => {
    return (
        RESTRICTED_COUNTRY_CODE.includes(userCountryCode) &&
        userCountryCode === targetPlanCountryCode
    );
};

// stripe key UAT
// export const STRIPE_PUBLISH_KEY="pk_test_51QLP6pE6iS4ghy75Cytwy4GAZ4hnRVAnS7waxpnEyghBWx5GoeT3WbSyJfVkXD57mCmSTy58YRZOFdI2lJsxUdhQ00Ja9tKhIN"
// stripe key Live
export const STRIPE_PUBLISH_KEY = "pk_live_51QLP6pE6iS4ghy75DZJsFbo27ka6OyR1u6GmiQSEnZdZNHgUfmgx6JDd7tGLBMSZd1O6C3OOI3hokQUJdNwtN19O00mlmu270q"